import TrendSignalsService  from "../../../../services/common/TrendSignalsService";

/**
 * @summary Cria o state de CustomDomain.
 * @returns State de CustomDomain.
 */
const EmptyCustomDomainStatefactory = function()
{
	return { selectedCustomDomainSignal: TrendSignalsService.TrendSignalSettingFactory() };
};

export default { EmptyCustomDomainStatefactory };